import React, { useState } from "react";
import { Container, Logo } from "./styles";
import { MenuOutlined, DownOutlined } from "@ant-design/icons";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";
import { useLanguage } from "../../hooks/LanguageContext";
import userPhoto from "../../images/user.png";
import logo from "../../images/logo.png";
import { Button, Drawer, Dropdown, Space, Typography } from "antd";
import Menu from "../Menu";
import { MdClose } from "react-icons/md";
import { BsPerson } from "react-icons/bs";

const { Text } = Typography;

const Header = ({ sidebar }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { language, changeLanguage } = useLanguage();
  const [visible, setVisible] = useState(false);

  const languageItems = [
    {
      key: "PT-br",
      label: (
        <Space onClick={() => changeLanguage("PT-br")}>
          <span style={{ fontSize: "16px" }}>🇧🇷</span> Português
        </Space>
      ),
    },
    {
      key: "EN-us",
      label: (
        <Space onClick={() => changeLanguage("EN-us")}>
          <span style={{ fontSize: "16px" }}>🇺🇸</span> English
        </Space>
      ),
    },
    {
      key: "ES-es",
      label: (
        <Space onClick={() => changeLanguage("ES-es")}>
          <span style={{ fontSize: "16px" }}>🇪🇸</span> Español
        </Space>
      ),
    },
  ];

  const getCurrentFlag = () => {
    switch (language) {
      case "PT-br":
        return "🇧🇷";
      case "EN-us":
        return "🇺🇸";
      case "ES-es":
        return "🇪🇸";
      default:
        return "🌐";
    }
  };

  return (
    <Container>
      <Button
        className="menu"
        type="primary"
        style={{ paddingBottom: 0 }}
        icon={<MenuOutlined />}
        onClick={() => setVisible(true)}
      />
      <Drawer
        title="Menu"
        placement="left"
        closeIcon={<MdClose color="#FFF" size={25} />}
        width={250}
        onClick={() => setVisible(false)}
        onClose={() => setVisible(false)}
        styles={{
          body: {
            background: "#008037",
            padding: 0,
          },
          header: {
            padding: "12px 10px",
            background: "#008037",
            color: "#FFF",
            fill: "#FFF",
          },
        }}
        open={visible}
      >
        <Menu />
      </Drawer>

      <Logo sidebar={sidebar}>
        <img src={logo} alt="" />
      </Logo>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 24,
          marginLeft: "auto",
        }}
      >
        <Dropdown menu={{ items: languageItems }} trigger={["click"]}>
          <Button type="text" style={{ height: "auto", padding: "4px 8px" }}>
            <Space>
              <span style={{ fontSize: "20px" }}>{getCurrentFlag()}</span>
              <Text strong style={{ color: "#fff" }}>
                {language}
              </Text>
              <DownOutlined style={{ fontSize: "10px", color: "#fff" }} />
            </Space>
          </Button>
        </Dropdown>

        {user && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="info" style={{ marginRight: 10, color: "#fff" }}>
              Olá, {user.name?.split(" ")[0] || ""}
            </p>
            <button
              onClick={() => {
                navigate(`/profile`);
              }}
            >
              <BsPerson color="#FFF" size={35} />
            </button>
          </div>
        )}
      </div>
    </Container>
  );
};

export default Header;
